import { COUNTRY_LIST } from "./CountryInput.content";

export function getCountryDetailsFromCountryCode(countryCode: string) {
  return COUNTRY_LIST.find(({ code }) => code === countryCode) || null;
}
